import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

const sanitize = (value) => String(value).replace(/[\s\-()]/g, "");

export const isValidNigerianPhone = (value) => {
  if (!value) return "Phone number is required";

  const cleaned = sanitize(value);

  if (!/^(\+234|0)/.test(cleaned)) {
    return "Phone number must start with 0 or +234";
  }

  try {
    const number = phoneUtil.parse(cleaned, "NG");

    if (!phoneUtil.isValidNumberForRegion(number, "NG")) {
      return "Enter a valid Nigerian phone number";
    }

    return true;
  } catch {
    return "Enter a valid Nigerian phone number";
  }
};

export const toNigerianE164 = (value) => {
  const cleaned = sanitize(value);

  try {
    const number = phoneUtil.parse(cleaned, "NG");
    return phoneUtil.format(number, PhoneNumberFormat.E164);
  } catch {
    return value;
  }
};